import BasicLayout from '@/apps/assessment/components/basic-layout/index.vue'
import ToolTip from '@/apps/assessment/components/tool-tip'
import AssessmentTrackMixin from '@/apps/assessment/mixins/assessment-track-mixin'
import RouterMixin from '@/apps/assessment/mixins/clazz-router-mixin'
import {
  adjustConfirm,
  adjustUnitTest,
  assignConfirm,
  getClazzList,
  getExamStatus,
  getPublishEdit,
  postPublishEdit,
  publishAssessment
} from '@/apps/assessment/model/api'
import {
  COlUMNS,
  labelCol,
  rangepicker,
  SUBJECT_TYPE_LIST,
  wrapperCol
} from '@/apps/assessment/model/publish'
import moment from 'moment'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import { Component, Mixins, Prop, Provide, Vue } from 'vue-property-decorator'

const dateFormat = 'YYYY-MM-DD HH:mm'
const examType = 'independent'
const UCENTER = process.env.VUE_APP_UCENTER_DOMAIN || 'https://ucenter.test.17zuoye.net/'
@Component({
  components: { BasicLayout, ToolTip, VueCtkDateTimePicker }
})
export default class ClazzAssessmentPublish extends Mixins(RouterMixin, AssessmentTrackMixin) {
  public testTime = ''
  public form: any = {
    // 测试名称，没有的情况下默认取试卷的名称，
    examName: '',
    // 测试类型
    useType: 'UNIT_TEST',
    // 年级
    clazzLevel: '',
    clazzs: [],
    range: [],
    examStartTime: '',
    examEndTime: '',
    // 考试时长
    durationMinutes: '',
    // 试卷信息
    paperInfo: {},
    // 是否已发布RAW/ONLINE
    status: '',
    subjectTypes: []
  }
  public rules = {
    examName: [{ required: true, message: '测评名称不能为空', trigger: 'blur' }],
    range: [
      {
        required: true,
        validator: this.checkDateRange,
        trigger: ['change', 'blur']
      }
    ],
    clazzLevel: [
      {
        required: true,
        message: '请选择年级',
        trigger: ['change']
      }
    ],
    examEndTime: [
      {
        required: true,
        validator: this.checkExamEndTime,
        trigger: ['change', 'blur']
      }
    ]
  }
  public scoreLevel = 0
  public examTypeList = []
  public subjectTypeList = SUBJECT_TYPE_LIST
  public clazzLevelList = []
  public groupForm = {
    groupName: ''
  }
  public rangepicker = rangepicker
  public moment = moment
  private labelCol = labelCol
  private wrapperCol = wrapperCol
  private columns = COlUMNS
  // 弹窗是否可见
  private groupVisible = false
  private paper = {}
  private paperName = ''
  private score = ''
  private schoolGroupIds = []
  private spinning = false
  private className = ''

  private get clazzs() {
    const choice: any = this.clazzLevelList.find((item: any) => {
      return this.form.clazzLevel === item.clazzLevel
    })
    return choice && choice.clazzs
  }

  private get teacherRoles() {
    return true
  }
  private get subject() {
    return this.$route.query.subject && String(this.$route.query.subject).toUpperCase()
  }
  private get subjectId() {
    return this.$route.query.subject_id
  }
  private get paperID() {
    return this.$route.query.pid
  }
  private get source() {
    return this.$route.query.s
  }
  private get examId() {
    return this.$route.query.exam
  }
  private get tid() {
    return this.$route.query.tid
  }
  private get f() {
    return this.$route.query.f ? decodeURIComponent(String(this.$route.query.f)) : ''
  }
  private get supportSubjects() {
    return this.$store.state.clazzSupportSubjects || []
  }
  private get assessmentType() {
    return this.$route && this.$route.meta && this.$route.meta.section
  }
  // 闵行区展示练习
  private get title() {
    return this.$store.state.user_info &&
    this.$store.state.user_info.regions &&
    this.$store.state.user_info.regions &&
    this.$store.state.user_info.regions[2].code == 310112
    ? '练习' : '测评'
  }
  // mount
  public mounted() {
    this.getClazzList()
    if (this.examId) {
      this.adjustUnitTest(this.examId)
    } else {
      this.getPublishEdit()
    }
  }
  // 获得班级名称
  public processClazzNames(level, groupids): string {
    // 先找到年级，再根据groupids 确定班级
    if (this.clazzLevelList && this.clazzLevelList.length) {
      let clazzs: any[] = []
      const grade: any = this.clazzLevelList.find((m: any) => {
        return m.clazzLevel === level
      })
      for (let m of grade.clazzs) {
        if (groupids.indexOf(m && m.groupId) > -1) {
          clazzs = [...clazzs, m]
        }
      }
      return (clazzs && clazzs.length > 0 && clazzs.map((m: any) => m.fullName).join('、')) || ''
    } else {
      return ''
    }
  }
  //
  public async adjustUnitTest(examId) {
    const data: any = await adjustUnitTest({ newExamId: examId })
    if (data.success) {
      // 测评调整
      this.paperName = data.practices.title
      this.className = data.clazz
      this.form.examStartTime = data.startDateTime
      this.form.examEndTime = data.endDateTime
      this.form.durationMinutes = data.practices.limitMinutes
    }
  }
  // 点击设置班组信息
  public onClazzsSettingClick() {
    window.open(UCENTER + '/teacher/systemclazz/clazzindex.vpage?step=showtip')
  }

  public async getClazzList() {
    const data: any = await getClazzList({ subject: this.subject })
    if (data.success) {
      if (data.clazzList && data.clazzList.length > 0) {
        this.clazzLevelList = data.clazzList.map((n) => {
          n.level = n.clazzLevel
          n.levelName = n.clazzLevelName
          return n
        })
      } else {
        // 如果没有班组信息跳转至主站用户中心
        this.$warning({
          title: '您尚未设置班组信息',
          content: '如需使用班级测评，请先设置班组信息哦',
          maskClosable: false,
          okText: '去设置',
          onOk: () => {
            this.onClazzsSettingClick()
          }
        })
      }
    } else {
      this.clazzLevelList = []
    }
  }
  public async adjustConfirm() {
    const assessmentSubject = this.supportSubjects.find((item) => item.nick === this.subject)
    this.trackRelease({
      buttonName: '发布',
      proSource: this.f,
      Assessment_subject: assessmentSubject && assessmentSubject.label,
      time: this.form.durationMinutes,
      Assessment_type: this.assessmentType,
      // 班级名称
      clazzs: this.className
    })
    const h = this.$createElement
    const data: any = await adjustConfirm({
      newExamId: this.examId,
      endDate: moment(this.form.examEndTime).format('YYYY-MM-DD HH:mm:ss') || ''
    })
    if (data.success) {
      const assessmentSubject = this.supportSubjects.find((item) => item.nick === this.subject)
      this.trackSuccess({
        result: '发布成功',
        proSource: this.f,
        Assessment_subject: assessmentSubject && assessmentSubject.label,
        time: this.form.durationMinutes,
        // 新增测评id选项
        Assessment_id: this.examId,
        Assessment_type: this.assessmentType,
        clazzs: this.className
      })
      this.trackEditDone({ Assessment_id: this.examId })
      const modal: any = this.$success({
        title: `${this.title}创建完成`,
        content: h('div', {}, [
          h('div', '学生可以在APP里进行查看和作答了'),
          h('div', `您可以在我的${this.title}-${this.title}列表中查看${this.title}详情`)
        ]),
        okText: `查看${this.title}列表`,
        onOk: () => {
          modal.destroy()
          this.$router.replace({
            path: '/myassessment/clazzlist',
            query: { subject: this.subject }
          })
        },
        onCancel() {
          modal.destroy()
        }
      })
    } else {
      this.$message.error(data.info)
    }
  }
  // 当选择年级时，其所包含的班级全选
  public onLevelChange() {
    // console.log(this.form.clazzLevel)
    const grade: any = this.clazzLevelList.find((n: any) => n.clazzLevel === this.form.clazzLevel)
    const gids = grade && grade.clazzs.map((n: any) => n.groupId)
    this.form.clazzs = gids
  }

  public onAdjust() {
    this.adjustConfirm()
  }
  // 获取弹窗容器
  public getPopupContainer() {
    return document.getElementById('publish')
  }
  // 添加分组
  public addGroup(): void {
    this.groupVisible = true
  }
  public cancelGroupmodal(): void {
    this.groupVisible = false
  }
  public editGroup(): void {
    this.groupVisible = true
  }
  public delGroup(): void {}
  public onGroupSave(): void {}
  public async getPublishEdit() {
    let params: any = {
      paperId: this.paperID,
      paperSource: this.source
    }
    if (this.tid) {
      params = {
        id: this.tid
      }
    }
    const data: any = await getPublishEdit(params)
    if (data.success) {
      this.form.subjectTypes = data.data.contentTypes
      this.form.useType = data.data.useType
      this.form.paperInfo = data.data.paperInfo
      this.paper = data.data.paperInfo
      this.paperName = data.data.paperName
      // 测评默认你使用试卷名称
      this.form.examName = data.data.examName ? data.data.examName : data.data.paperName
      this.score = data.data.paperInfo.totalScore
      this.schoolGroupIds = data.data.schoolGroupIds
      // 测评时间字段更改，只读
      this.form.durationMinutes = data.data.paperInfo.examTime
      // 班级回显
      this.form.clazzs =
        data.data.groupIds && data.data.groupIds.length > 0 ? data.data.groupIds : []

      if (this.tid) {
        this.scoreLevel = data.data.rankType
        this.form.clazzLevel = data.data.clazzLevel
        this.form.durationMinutes = data.data.durationMinutes
        this.form.examEndTime = data.data.examEndTime
        this.form.examName = data.data.examName
        this.form.examStartTime = data.data.examStartTime
        this.form.paperInfo = data.data.paperInfo
        this.form.studentVisible = data.data.studentVisible
        this.form.range = [data.data.examStartTime, data.data.examEndTime]
        this.paperName = data.data.paperInfo.paperName
      }
    } else {
      // 提示报错
      this.$message.error(data.error)
    }
  }
  public async publishAssessment(examId) {
    const dateFormat = 'YYYY-MM-DD HH:mm:ss'
    const groupIds = this.form.clazzs
    const extra = {
      paperIds: this.form.paperInfo.paperId,
      groupIds: groupIds.join(','),
      startTime: this.form.range[0] ? moment(this.form.range[0]).format(dateFormat) : '',
      endTime: this.form.range[1] ? moment(this.form.range[1]).format(dateFormat) : ''
    }
    const params = { examData: JSON.stringify(extra), subject: this.subject }
    const h = this.$createElement
    this.spinning = true
    try {
      console.log(params)
      // 保存至修改
      const data: any = await assignConfirm(params)
      const self = this
      if (data.success) {
        this.trackSuccessMethod('发布成功', examId)
        this.trackEditDone({ Assessment_id: examId }) // 新增发布成功id采集
        const modal: any = this.$success({
          title: `${this.title}创建完成`,
          content: h('div', {}, [
            h('div', '学生可以在APP里进行查看和作答了'),
            h('div', `您可以在我的${this.title}-班级${this.title}中查看${this.title}详情`)
          ]),
          okText: `查看${this.title}列表`,
          onOk: () => {
            modal.destroy()
            this.$router.replace({
              path: '/myassessment/clazzlist',
              query: { subject: this.subject }
            })
          },
          onCancel() {
            modal.destroy()
          }
        })
      } else {
        this.$message.error(data.info)
      }
    } catch (e) {
      console.log(e)
    } finally {
      this.spinning = false
    }
  }
  public async postPublishEdit(TYPE) {
    const groupIds = this.form.clazzs
    const extra = {
      status: TYPE,
      subjectId: Number(this.subjectId),
      subject: this.subject,
      examStartTime: this.form.range[0] ? moment(this.form.range[0]).format(dateFormat) : '',
      examEndTime: this.form.range[1] ? moment(this.form.range[1]).format(dateFormat) : '',
      // rankType: this.scoreLevel,
      examName: this.form.examName,
      clazzLevel: this.form.clazzLevel,
      paperInfo: this.form.paperInfo,
      useType: this.form.useType,
      schoolGroupIds: this.schoolGroupIds,
      paperSource: this.source,
      durationMinutes: this.form.durationMinutes,
      id: this.tid ? this.tid : undefined,
      groupIds,
      examType
    }
    const params = { ...extra }
    // 保存至修改
    this.spinning = true
    try {
      const data: any = await postPublishEdit(params)
      const h = this.$createElement
      if (data.success) {
        const examId = data.data.examId
        if (TYPE === 'RAW') {
          this.trackSuccessMethod('保存成功', undefined)
          const modal: any = this.$success({
            title: '已保存',
            content: h('div', {}, [h('div', `您可以在我的${this.title}-班级${this.title}中查看${this.title}详情`)]),
            okText: `查看${this.title}列表`,
            onOk: () => {
              modal.destroy()
              this.$router.replace({
                path: '/myassessment/clazzlist',
                query: { subject: this.subject, pb: '1' }
              })
            },
            onCancel: () => {
              modal.destroy()
            }
          })
        } else {
          this.trackSuccessMethod('发布成功', examId)
          this.trackEditDone({ Assessment_id: examId })
          const modal: any = this.$success({
            title: `${this.title}创建完成`,
            content: h('div', {}, [
              h('div', '学生可以在APP里进行查看和作答了'),
              h('div', `您可以在我的${this.title}-班级${this.title}中查看${this.title}详情`)
            ]),
            okText: `查看${this.title}列表`,
            onOk: () => {
              modal.destroy()
              this.$router.replace({
                path: '/myassessment/clazzlist',
                query: { subject: this.subject }
              })
            },
            onCancel: () => {
              modal.destroy()
            }
          })
        }
      } else {
        this.$message.error(data.error)
      }
    } catch (e) {
      console.log(e)
    } finally {
      this.spinning = false
    }
  }
  // 点击发布、保存至测评列表
  public trackReleaseMethod(buttonName) {
    const exam: any = this.examTypeList.find(
      (item: { type: string; typeName: string }) => item.type === this.form.useType
    )
    const item = this.subjectTypeList.map((n) => {
      for (let m of this.form.subjectTypes) {
        if (m === n.type) {
          return n.typeName
        }
      }
    })
    const Grade: any = this.clazzLevelList.find((n: any) => n.level == this.form.clazzLevel)
    const clazzs = Grade && this.processClazzNames(Grade.level, this.form.clazzs)
    const assessmentSubject = this.supportSubjects.find((item) => item.nick === this.subject)
    this.trackRelease({
      buttonName,
      proSource: this.f,
      Assessment_subject: assessmentSubject && assessmentSubject.label,
      type: exam && exam.typeName,
      item: item.join(','),
      Grade: Grade && Grade.levelName,
      time: this.form.durationMinutes,
      Assessment_type: this.assessmentType,
      // 班级名称
      clazzs,
      groupIds: this.form.clazzs.join(',')
    })
  }
  // 保存成功、发布成功
  public trackSuccessMethod(result, examId?) {
    const exam: any = this.examTypeList.find(
      (item: { type: string; typeName: string }) => item.type === this.form.useType
    )
    const item = this.subjectTypeList.map((n) => {
      for (let m of this.form.subjectTypes) {
        if (m === n.type) {
          return n.typeName
        }
      }
    })
    const Grade: any = this.clazzLevelList.find((n: any) => n.level == this.form.clazzLevel)
    const clazzs = Grade && this.processClazzNames(Grade.level, this.form.clazzs)
    const assessmentSubject = this.supportSubjects.find((item) => item.nick === this.subject)
    this.trackSuccess({
      result,
      proSource: this.f,
      Assessment_subject: assessmentSubject && assessmentSubject.label,
      type: exam && exam.typeName,
      item: item.join(','),
      Grade: Grade && Grade.levelName,
      time: this.form.durationMinutes,
      // 新增测评id选项
      Assessment_id: examId,
      Assessment_type: this.assessmentType,
      clazzs,
      groupIds: this.form.clazzs.join(',')
    })
  }
  // 发布
  public onSubmit(): void {
    this.trackReleaseMethod('发布')
    const refs: any = this.$refs
    refs.ruleForm.validate((valid) => {
      if (valid) {
        if (this.tid) {
          this.getExamStatus(this.tid)
        } else {
          this.postPublishEdit('ONLINE')
        }
      } else {
        console.log('error submit!!')
        return false
      }
    })
  }
  public onSubmitMain() {
    this.trackReleaseMethod('发布')
    const refs: any = this.$refs
    refs.ruleForm.validate((valid) => {
      if (valid) {
        this.publishAssessment(this.examId)
      } else {
        console.log('error submit!!')
        return false
      }
    })
  }
  // 保存
  public save(): void {
    this.trackReleaseMethod('保存至测评列表')
    const refs: any = this.$refs
    refs.ruleForm.validate((valid) => {
      if (valid) {
        this.postPublishEdit('RAW')
      } else {
        console.log('error submit!!')
        return false
      }
    })
  }
  // 返回上级页面
  public back(): void {
    console.log(this.ROUTER_FROM)
    if (this.source === 'PERSONAL_ASSESSMENT') {
      if (this.ROUTER_FROM && this.ROUTER_FROM.path) {
        if (this.ROUTER_FROM.path === '/clazzpreview') {
          this.$router.push({ path: '/clazz' })
        } else {
          this.$router.back()
        }
      } else {
        this.$router.push({ path: '/clazz' })
      }
    } else {
      this.$router.back()
    }
  }
  // getExamStatus
  public async getExamStatus(id) {
    try {
      const data: any = await getExamStatus({ id })
      if (data.success) {
        if (data.data.status === 'RAW') {
          this.postPublishEdit('ONLINE')
        } else {
          this.publishAssessment(data.data.examId)
        }
      }
    } catch (e) {
      console.log(e)
    }
  }
  //
  public range(start, end) {
    const result: any[] = []
    for (let i = start; i < end; i++) {
      result.push(i)
    }
    return result
  }
  // 设置日期range插件禁用日期
  public disabledRangeDate(current) {
    if (this.form.examStartTime) {
      return current && current < moment(this.form.examStartTime, 'YYYY-MM-DD')
    } else {
      return current && current < moment().add(-1, 'days')
    }
  }
  // 校验 datetime-picker ，后面文案可以单独抽离出来，存放在一个配置文件中
  public checkDateRange(rule, value, callback) {
    if (value && value.length > 0) {
      const [start, end] = value.map((item) => moment(item))
      const minutes = end.diff(start, 'minutes')
      // 用时间区间差值与答题总时长进行比对，
      if (minutes >= Number(this.form.durationMinutes)) {
        callback()
      } else {
        callback(`${this.title}截止时间”不能早于“${this.title}开始时间”+“答题时长`)
      }
    } else {
      callback(`请选择${this.title}开始时间和${this.title}结束时间`)
    }
  }
  // 校验试卷答题总时长
  public checkDurationMinutes(rule, value, callback) {
    if (value) {
      const [start, end] = this.form.range.map((item) => moment(item))
      const minutes = end.diff(start, 'minutes')
      // 比较答题时长与测评开始、结束时间的差值
      if (value > minutes) {
        callback(`试卷总答题时长需小于${this.title}结束时间-${this.title}开始时间`)
      } else {
        callback()
      }
    } else {
      callback('请填写答题时长')
    }
  }
  // checkExamEndTime
  public checkExamEndTime(rule, value, callback) {
    if (value) {
      const start = moment(this.form.examStartTime, dateFormat)
      const minutes = value.diff(start, 'minutes')
      // 比较答题时长与测评开始、结束时间的差值
      if (minutes < Number(this.form.durationMinutes)) {
        callback('测评截止时间”不能早于“测评开始时间”+“答题时长')
      } else {
        callback()
      }
    } else {
      callback('请填写测评截止时间')
    }
  }
}
